const ENV = import.meta.env.VITE_ENV_NAME

function envSubdomain(): string {
    if (ENV === 'dev') return 'dev.'
    if (ENV === 'uat') return 'uat.'
    return ''
}

// USA agencies — both the legacy 'usa' slug and the ISO 'US' code (agencies
// saved before primaryMarket switched to ISO 3166-1 alpha-2 still use the former).
export const isUsMarket = (primaryMarket?: string) => primaryMarket === 'usa' || primaryMarket === 'US'

// The traveler-facing redemption link a code resolves to. The USA market runs on
// the English gift.* host, every other market on the Spanish regalo.* one. Checks
// both the legacy 'usa' slug and the ISO 'US' code — agencies saved before the
// primaryMarket field switched to ISO 3166-1 alpha-2 codes still use the former.
export function redemptionUrlPrefix(primaryMarket?: string): string {
    return (isUsMarket(primaryMarket) || (primaryMarket && !primaryMarket.startsWith('spain')))
        ? `https://gift.${envSubdomain()}51trips.com/invitation?code=`
        : `https://regalo.${envSubdomain()}51trips.com/invitacion?code=`
}

// The link to show for a code: the deliverable the metrics response minted when
// it has one, else the redemption link built from the code itself — printed
// rows never carry a deliverableUrl, and a code the ETL hasn't seen yet doesn't
// either, but both resolve to the same link.
export function deliverableLink(deliverableUrl: string | null, code: string | null, primaryMarket?: string): string | null {
    return deliverableUrl ?? (code ? `${redemptionUrlPrefix(primaryMarket)}${code}` : null)
}
